// node_modules
import { FC } from "react";
import { Link } from "react-router-dom";
// Types
import { TMagDocumentDTO } from "Types";
// Components
import { FindestButton } from "..";
// styles
import styles from "./magDocumentContent.module.scss";
import "styles/documentHighlights.scss";
// Helpers
import { DateHelperSingleton } from "Helpers";
// Custom hooks
import { useTextSelection } from "Hooks";

type TMagDocumentContentProps = {
    magDocument: TMagDocumentDTO,
    highlightedAbstract?: string,
}

export const MagDocumentContent: FC<TMagDocumentContentProps> = ({ magDocument, highlightedAbstract }: TMagDocumentContentProps) => {
    // Let
    const { setSelectedTextOnMouseEvent, selectedText, selectionBoundingClientRect } = useTextSelection();
    
    // Render
    return (
        <>
            <div className={styles.magDocumentContentFullInfo}>
                <div className={[styles.infoColumn, styles.metadataContainer].join(" ")}>
                    <Link to={{ pathname: magDocument.openAccessUrl ? magDocument.openAccessUrl : magDocument.url }} target={"_blank"} rel={"noopener noreferrer"} >
                        <FindestButton title="Link to Article" />
                    </Link>

                    {magDocument.publishDate ?
                        <div className={styles.metadata}>
                            <h5>Publishing date</h5>
                            <h6 onMouseUp={setSelectedTextOnMouseEvent} className="publishing-date">
                                {DateHelperSingleton.getFormattedDate(new Date(magDocument.publishDate))}
                            </h6>
                        </div>
                        : <></>
                    }

                    {magDocument.affiliations && magDocument.affiliations.length > 0 ?
                        <div className={styles.metadata}>
                            <h5>Affilations</h5>
                            <h6 onMouseUp={setSelectedTextOnMouseEvent} className="author">
                                {magDocument.affiliations.map((affiliation) => { 
                                        if(affiliation.affiliation.startsWith("\"")) {
                                            return affiliation.affiliation.substring(1).trim();
                                        } else{
                                            return affiliation.affiliation.trim();
                                        }
                                    }).join(", ")}
                            </h6>
                        </div>
                        : <></>
                    }
                    {magDocument.authors && magDocument.authors.length > 0 ?
                        <div className={styles.metadata}>
                            <h5>Authors</h5>
                            <h6 onMouseUp={setSelectedTextOnMouseEvent} className="author">
                                {magDocument.authors.map((author) => { return author.author; }).join(", ")}
                            </h6>
                        </div>
                        : <></>
                    }

                </div>

                <div className={styles.infoColumn}>
                    <h5>Abstract</h5>
                    {magDocument.abstract ?
                        highlightedAbstract ?
                            <h6 onMouseUp={setSelectedTextOnMouseEvent} dangerouslySetInnerHTML={{__html: highlightedAbstract}}></h6>
                            :
                                <h6 onMouseUp={setSelectedTextOnMouseEvent}>{magDocument.abstract}</h6>
                                : <h6>No Abstract was provided</h6>
                    }
                </div>

            </div>
        </>
    );
};